import { createRouter, createWebHistory } from "vue-router";
import AppHome from "../components/AppHome.vue";
import AppDev from "../components/AppDeveloper.vue";
import AppLogin from "../components/AppLogin.vue";
import AppProfile from "../components/AppProfile.vue";
import AppNotFound from "../components/AppNotFound.vue";
import AppForbidden from "../components/AppForbidden.vue";
import AppCondena from "../components/AppCondena.vue";
import { isAuthenticated } from "../auth";
import AppGogoPoints from "@/components/AppGogoPoints.vue";
import AppConstruccion from "@/components/AppConstruccion.vue";
import AppRegister from "@/components/AppRegister.vue";
import AppFurina from "@/components/AppFurina.vue";

const routes = [
  { path: "/", component: AppHome },
  { path: "/dev", component: AppDev },
  { path: "/proyect", component: AppConstruccion },
  { path: "/app", component: AppConstruccion },
  { path: "/condena", component: AppCondena },
  { path: "/proyect/terms-of-service", component: AppConstruccion },
  { path: "/login", component: AppLogin },
  { path: "/register", component: AppRegister },
  { path: "/furina", component: AppFurina },
  { path: "/gogopoints", component: AppGogoPoints },
  {
    path: "/profile",
    component: AppProfile,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) next();
      else next("/forbidden");
    },
  },
  { path: "/forbidden", component: AppForbidden },
  { path: "/:pathMatch(.*)*", component: AppNotFound },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;